export const PATH = {
  HOME: '/home',
  MENU: '/menu',
  INVENTORY: '/inventory',
  FACTORIES: '/factories',
  DEPARTMENTS: '/inventory/1',
  CATEGORIES: '/inventory/2',
  ITEMS: '/inventory/3',
  CHECKOUT: '/menucheckout',
  THANKYOU: '/thankyou',
};

export default PATH;
